import { Validators } from '@angular/forms';
import * as moment from 'moment';


export class Organization {
    [x: string]: any;
    id?: number;
    name?: string;
    name_eng?: string;
    address1?: string;
    address2?: string;
    tax_id?: string;
    fax_no?: string;
    license_no?: string;
    token?: string;
    expire_at?: Date;
    tel?: string;
    line_id?: string;
    email?: string;
    website?: string;
    logo?: string;
    bill_coppy?: string;
    online_store ?:  string|null|undefined;

    constructor(org){
        this.id = org.id;
        this.name = org.name || [org.name, Validators.required];
        this.name_eng = org.name_eng || [org.name_eng];
        this.address1 = org.address1;
        this.address2 = org.address2;
        this.tax_id = org.tax_id;
        this.token = org.token;
        this.fax_no = org.fax_no;
        this.license_no = org.license_no;
        this.expire_at = org.expire_at|| [org.expire];
        this.tel = org.tel || [org.tel];
        this.line_id = org.line_id;
        this.email = org.email;
        this.website = org.website;
        this.logo = org.logo
        this.bill_coppy = org.bill_coppy
        this.online_store = org.online_store
    }

}
